import React, { useState, useContext, useEffect } from 'react';
import Calculator from "../../../../img/icons/calculator.svg";
import { RadioButton } from "../../../common/inputs/radioButton/radioButton";
export default function Commencement(props) {
    return (
        <div >

            <div className='row'>
                <div className='col-lg-5'>
                    <div className="logo text-center mb-2 mt-2  ">
                        <img src={Calculator} alt="Fifo Calculator" />
                    </div>
                    <div className='text-center'>
                        <h6>Commencement Dates</h6>
                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. orem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                    </div>
                </div>
                <div className='col-lg-7'>

                    <div>
                        <div className="d-sm-flex w-100  py-3 align-items-center ">
                            <div className="custom-control custom-radio custom-control-inline"></div>
                            <div className='col-lg-10'>

                                <div className="border rounded-xl p-4 shadow-sm mb-3   font-weight-bold">


                                    <div className="form-group p-2">
                                        <label>Set Commencement Date</label>
                                        <div >  <input typeof='text' className='form-control' name="purchase_order_no" value="" label="Purchase Order Number" reference="" onChange="" type="" /></div>
                                    </div>
                                    <div className="form-group p-2">
                                        <label>Set the date the program is to go live</label>
                                        <div >  <input typeof='text' className='form-control' name="purchase_order_no" value="" label="Purchase Order Number" reference="" onChange="" type="" /></div>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </div>

        </div>
    );
}